import React from 'react'
import { FormCheck } from 'atoms/Inputs'

export const checkFormatter = (cellContent, row, rowIndex, formatExtraData) => {
  const { allowEdit, field, subField, fn } = formatExtraData
  return (
    <FormCheck
      value={subField ? row[field][subField] : row[field]}
      allowEdit={allowEdit}
      fn={fn(row, field, rowIndex)}
    />
  )
}
